import Dialog from '@material-ui/core/Dialog';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import styled from 'styled-components';
import FunctionsContext from './FunctionsContext';
import WorkflowForm from './WorkflowForm';
import Divider from '@material-ui/core/Divider';


const Container = styled.div`
    min-width:680px;
    display:flex;
    flex-direction:column;

    padding-bottom:40px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: white;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    height:80px;
    background-color:RGB(48, 74, 87);
    display:flex;
    align-items:center;
`;

const ContainerSteps = styled.div`
`;


class WorkflowDialog extends React.Component {

    static contextType = FunctionsContext;


    render()
    {
        const {selectedFunctionDetails} = this.context.functions;

        return (
            <Dialog maxWidth='xl' open={this.context.workflowDialogOpen}>
                <Container>
                    <ContainerHeader>Edit Workflow</ContainerHeader>
                    <ContainerSteps>
                    {selectedFunctionDetails &&
                               <WorkflowForm context={this.context}  initialValues={selectedFunctionDetails}/>
                        }
                    </ContainerSteps>
                </Container>
            </Dialog>
        )
    }

}

export default WorkflowDialog;